// src/DashboardTabs.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles/dashboardTabs.css";

const DashboardTabs = () => {
  const { state } = useLocation(); // Access data passed from Home
  const navigate = useNavigate();

  const tab = state?.tab || "outstanding";
  const data = state?.data || [];

  const titleMap = {
    overdue: "Overdue Invoices",
    outstanding: "Outstanding Invoices",
    payments: "Recent Payments",
  };

  return (
    <div className="dashboard-tabs-container">
      <h2>{titleMap[tab]}</h2>
      <button onClick={() => navigate("/")}>← Back</button>

      <table className="dashboard-table">
  <thead>
    {tab === "payments" ? (
      <tr>
        <th>Payment ID</th>
        <th>Client</th>
        <th>Amount</th>
        <th>Mode</th>
        <th>Date</th>
      </tr>
    ) : (
      <tr>
        <th>Invoice #</th>
        <th>Client</th>
        <th>Amount</th>
        <th>Description</th>
        <th>Due Date</th>
        <th>Status</th>
      </tr>
    )}
  </thead>
  <tbody>
    {data.length > 0 ? (
      data.map((row, index) =>
        tab === "payments" ? (
          <tr key={index}>
            <td>{row.id}</td>
            <td>{row.client}</td>
            <td>${Number(row.amount).toFixed(2)}</td>
            <td>{row.mode}</td>
            <td>{new Date(row.payment_date).toLocaleDateString()}</td>
          </tr>
        ) : (
          <tr key={index}>
            <td>{row.invoice_number}</td>
            <td>{row.full_name}</td>
            <td>${Number(row.amount).toFixed(2)}</td>
            <td>{row.item || "—"}</td>
            <td>{new Date(row.due_date).toLocaleDateString()}</td>
            <td>
              <span className={`status-badge ${tab.toLowerCase()}`}>
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </span>
            </td>
          </tr>
        )
      )
    ) : (
      <tr>
        <td colSpan="6">No records found.</td>
      </tr>
    )}
  </tbody>
</table>

    </div>
  );
};

export default DashboardTabs;
